import React from 'react';

class Button extends React.Component {


    handleClick = (e) => {
        if(this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render () {
        const noMargin = this.props.no_margin ? 'no-margin' : ''
        const secondary = this.props.secondary ? 'secondary' : ''
        const disabled = this.props.disabled ? true : false
        const className = this.props.className ? this.props.className : ''
        const link = this.props.target === '_blank' ?
            <a type="button" href={this.props.href} target="_blank" rel="noopener noreferrer" className={`${noMargin} ${secondary}`}>{this.props.value}</a>
        :
            <button className={`${noMargin} ${secondary} ${className}`} disabled={disabled}  type="button" onClick={this.handleClick.bind(this)}>{this.props.value}</button>

        return (
            link
        )
    }
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Form/Button.js